export const getUniqueCountriesData = (
  data: { location: string; choosable: boolean }[]
) => {
  const countryMap = new Map<
    string,
    { location: string; choosable: boolean }
  >();

  data.forEach((item) => {
    if (item.location) {
      const country = item.location.split(", ").pop(); // Берём страну
      if (country && !countryMap.has(country)) {
        countryMap.set(country, item); // Сохраняем первый встретившийся объект для страны
      }
    }
  });

  return Array.from(countryMap.values());
};

export const getFilteredAgeRanges = (
  ageRanges: {
    lable: string;
    value: string;
  }[],
  minMax: { min: number; max: number }
) => {
  return ageRanges.map((range) => {
    const [rangeMin, rangeMax] = range.value.split(" ").map(Number);
    const isDisabled = rangeMax < minMax.min || rangeMin > minMax.max;
    return { ...range, disabled: isDisabled };
  });
};
